import React, { useEffect, useRef } from 'react'
import classNames from 'classnames'
import ConsentBadge from './ConsentBadge'
import StatusIcon from './StatusIcon'

import style from './PageTitle.module.css'

export default function PageTitle({
  showStatusIcon = true,
  label,
  secondaryText,
  consentType,
  status,
}) {
  const title = useRef()
  useEffect(() => {
    title.current.focus()
  }, [])

  return (
    <h1 className={`${style.heading} js-page-title`} tabIndex="-1" ref={title}>
      <ConsentBadge consentType={consentType} className={style.badge}>
        {showStatusIcon && (
          <StatusIcon status={status} className={style.icon} />
        )}
        <span
          className={classNames(
            style.label,
            { [style.small]: label.length > 28 },
            'js-title-label'
          )}
        >
          {label}
        </span>
        <span className={`${style.secondaryText} js-title-secondary-text`}>
          {secondaryText}
        </span>
      </ConsentBadge>
    </h1>
  )
}
